import { HttpClient } from '@angular/common/http';
import { Injectable }          from '@angular/core';
import { environment } from '@omnienv/omnicms/devcms/environment';
import { CreatePaymentModel } from '@omnilnp/models/create-payment.model';
import { HostedCheckoutResponse } from '@omnilnp/models/hosted-checkout-response.model';
import { PaymentStatusResponse } from '@omnilnp/models/payment-status-response.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
    constructor(
        private httpClient: HttpClient
    ){
    }

    public getHostedCheckout(createPaymentModel: CreatePaymentModel): Observable<HostedCheckoutResponse> {
        return this.httpClient.post<HostedCheckoutResponse>(environment.apiurl + "payment/worldline/create-hosted-checkout", createPaymentModel)
    }

    public getPaymentStatus(checkoutId: string): Observable<PaymentStatusResponse> {
        return this.httpClient.get<PaymentStatusResponse>(environment.apiurl + "payment/worldline/status/" + checkoutId);
    }
}